import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const FirebaseActionHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get('mode');       // 'resetPassword', 'verifyAndChangeEmail', etc.
    const oobCode = queryParams.get('oobCode'); // The secret Firebase token

    if (!oobCode) {
      alert("Missing action configuration tracking token.");
      navigate('/login-parm');
      return;
    }

    // 🟢 ROUTING SWITCH MATRIX
    switch (mode) {
      case 'resetPassword':
        // Redirects to your ResetPasswordHandler page with the token intact
        navigate(`/reset-password-parm?oobCode=${oobCode}`);
        break;

      case 'verifyAndChangeEmail':
      case 'recoverEmail':
        // Redirects to your EmailUpdateHandler page with the token intact
        navigate(`/update-email-parm?oobCode=${oobCode}`);
        break;

      default:
        console.warn(`Unknown action execution mode: ${mode}`);
        navigate('/login-parm');
        break;
    }
  }, [location, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div className="loader">Securing connection routing parameters...</div>
    </div>
  );
};

export default FirebaseActionHandler;